var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"请完成安全验证","visible":_vm.visible,"width":"360px"},on:{"update:visible":function($event){_vm.visible=$event},"opened":_vm.dialog_open}},[_c('div',{staticClass:"nc-container",attrs:{"id":"nc-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }